import { Button, CircularProgress, Grid2 } from "@mui/material";
type Props = {
	isSubmitLoading?: boolean;
	disabled?: boolean;
	onHide: (proceed: boolean) => void;
	buttonColor?:
		| "inherit"
		| "primary"
		| "secondary"
		| "success"
		| "error"
		| "info"
		| "warning"
		| undefined;
	buttonLabel?: "Delete" | "Save" | string;
	className?: string;
};
export const FooterModalButtons = ({
	isSubmitLoading = false,
	disabled = false,
	onHide,
	buttonColor = "primary",
	buttonLabel = "Save",
	className,
}: Props) => {
	return (
		<Grid2 container spacing={2} justifyContent="flex-end">
			<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
				<Button
					fullWidth
					variant="contained"
					color="inherit"
					onClick={() => onHide(false)}
					className={className}
				>
					Cancel
				</Button>
			</Grid2>
			<Grid2 size={{ md: 3, xs: 12 }} style={{ margin: 0 }}>
				<Button
					fullWidth
					startIcon={isSubmitLoading && <CircularProgress size="1rem" />}
					disabled={isSubmitLoading || disabled}
					variant="contained"
					color={buttonColor}
					type="submit"
					className={className}
				>
					{buttonLabel}
				</Button>
			</Grid2>
		</Grid2>
	);
};
